module.exports = __webpack_public_path__ + "static/media/firststock.84e0b4c6.png";